// import { ValidationErrorMessage } from './../constants/ValidationErrorMessage';
// import { Image } from './../_models/category-data-form';
import { DomSanitizer } from '@angular/platform-browser';
// import { Product } from './../_models/product';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, OnInit, Inject, Optional } from '@angular/core';
import { JsonPipe } from '@angular/common';
import { element } from 'protractor';
import { ValidationErrorMessage } from '../constants/validation';

@Component({
  selector: 'app-product-image',
  templateUrl: './product-image.component.html',
  styleUrls: ['./product-image.component.scss']
})
export class ProductImageComponent implements OnInit {
  localData: any[];
  productMainImage: any;

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ProductImageComponent>,
    public sanitizer: DomSanitizer) {
    let lData = [];
    lData.push(this.data)
    this.localData = lData
  }

  
  ngOnInit() {
    console.log(this.data)
    this.productMainImage= JSON.parse(JSON.stringify(this.data.productData))
    console.log(" Product_image component this.productMainImage",this.productMainImage)
    
  //  this.productMainImage="http://www.homefabricsindia.com:8080/home-fabrics/productImages/YEP%20TAPE%204%20CANVAS%20IVORY%20FOG.jpg"
   // this.productMainImage="http://54.187.185.32:8080//home-fabrics/productImages/LIAZ%20TAPE%204%20CANVAS%20IVORY%20FUSSIA.jpg"
  }
  zoomFactor = 1.0;
  readonly maxZoomFactor = 3.0;
  readonly minZoomFactor = 1.0;
  zoomin(){
    
    if (this.zoomFactor < this.maxZoomFactor) {
      this.zoomFactor += 0.3;
    } 
  } 
  
  zoomout(){
    if (this.zoomFactor > this.minZoomFactor) {
      this.zoomFactor -= 0.3;
    }
  }
  containerWidth: number = 0;
  containerHeight: number = 0;
  getImageSize(image: HTMLImageElement): void {
    const originalWidth = image.naturalWidth;
    const originalHeight = image.naturalHeight;
    console.log('Original Width:', originalWidth);
    console.log('Original Height:', originalHeight);
  }
}

